import { entryItems } from "@/mocks/homeData";
import SectionHead from "./SectionHead";

export default function EntryGrid() {
  return (
    <section id="entry" className="mx-auto max-w-[1240px] scroll-mt-24 px-4 py-10 md:px-6 md:py-14">
      <SectionHead
        kicker="layouts-line"
        title="六大内容入口，一键落地"
        sub="六条路径承载全站内容体系，按你的浏览习惯选择入口即可开刷。"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {entryItems.map((it, idx) => (
          <a
            key={it.name}
            href="#tags"
            className="group relative flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
          >
            <div className="flex items-start justify-between">
              <span
                className={
                  "flex h-11 w-11 items-center justify-center rounded-md text-xl " +
                  (idx % 3 === 1
                    ? "bg-accent-100 text-accent-700"
                    : idx % 3 === 2
                      ? "bg-secondary-100 text-secondary-900"
                      : "bg-primary-100 text-primary-700")
                }
              >
                <i className={it.icon} aria-hidden="true" />
              </span>
              <span className="flex items-baseline gap-1">
                <span className="font-display text-2xl font-bold text-foreground-950">{it.count}</span>
                <span className="text-[11px] text-foreground-400">个</span>
              </span>
            </div>

            <h3 className="mt-4 flex items-center gap-2 text-lg font-bold text-foreground-950">
              {it.name}
              <span className="text-[11px] font-normal tracking-widest text-foreground-400">{it.en}</span>
            </h3>
            <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{it.desc}</p>

            <div className="mt-4 flex flex-wrap items-center gap-2">
              {it.subs.map((s) => (
                <span
                  key={s}
                  className="inline-flex items-center rounded-full bg-background-200/70 px-2.5 py-0.5 text-xs text-foreground-700"
                >
                  {s}
                </span>
              ))}
            </div>

            <span className="mt-5 inline-flex items-center gap-1 text-xs font-medium text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
              进入{it.name}
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}